import privacy from './privacy';
export default privacy;
